import apiClient from "./base.service";

export default {
    async index(event) {
        return await apiClient.get(`/event/${event}/guest`);
    },
    async get(event, id) {
        return await apiClient.get(`/event/${event}/guest/${id}`);
    },
    async update(event, id, data) {
        return await apiClient.put(`/event/${event}/guest/${id}`, data);
    },
    async create(event, data) {
        return await apiClient.post(`/event/${event}/guest`, data);
    },
    async remove(event, id) {
        return await apiClient.delete(`/event/${event}/guest/${id}`);
    }
}